import { useAccount } from '@nizza/core';

const useAccountCurrencyConfig = () => {
  const { account, isLoading } = useAccount();

  return {
    accountCurrencyConfig: account?.currencyConfig,
    isLoading,
  };
};

export default useAccountCurrencyConfig;
